<template>
  <AuthLayout>
      <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center;">
        <div class="container blue lighten-5 z-depth-3 center-align" style="max-width: 420px; padding: 50px;">
      
          <!-- Loading State -->
          <div v-if="status === 'verifying'">
            <div class="preloader-wrapper active" style="margin-bottom: 20px;">
              <div class="spinner-layer spinner-blue-only">
                <div class="circle-clipper left"><div class="circle"></div></div>
                <div class="gap-patch"><div class="circle"></div></div>
                <div class="circle-clipper right"><div class="circle"></div></div>
              </div>
            </div>
            <h5 class="blue-text text-darken-4 bold">Verifying Email...</h5>
            <p>Please wait while we secure your account.</p>
          </div>
          <!-- Success State -->
          <div v-else-if="status === 'success'">
            <i class="material-icons green-text" style="font-size: 4rem;">check_circle</i>
            <h5 class="green-text bold">Email Verified!</h5>
            <p>Your email has been successfully verified. Redirecting you to the login page...</p>
          </div>
          <!-- Error State -->
          <div v-else-if="status === 'error'">
            <i class="material-icons red-text" style="font-size: 4rem;">error</i>
            <h5 class="red-text bold">Verification Failed</h5>
            <p>{{ errorMessage }}</p>
            <button class="btn blue darken-3" style="margin-top: 20px;" @click="$router.push('/')">
              Return to Login
            </button>
          </div>
        </div>
      </div>
  </AuthLayout>
</template>

<script>
import api from "../axios"; // Make sure this points to your configured axios
import AuthLayout from "./layout/AuthLayout.vue";

export default {
  name: "VerifyEmailView",
  components: {
    AuthLayout
  },
  data() {
    return {
      status: "verifying", // verifying, success, error
      errorMessage: "The verification link is invalid or has expired."
    };
  },
  mounted() {
    this.verifyEmail();
  },
  methods: {
    async verifyEmail() {
      // 1. Safely extract the URL without letting Vue Router mangle the signature
      const urlParams = new URLSearchParams(window.location.search);
      const verifyUrl = urlParams.get('verify_url');

      if (!verifyUrl) {
        this.status = "error";
        return;
      }

      try {
        // 2. Ping the Laravel backend using your configured API instance
        // We force the Accept header so Fortify returns a 204 No Content instead of a Redirect
        await api.get(verifyUrl, {
          headers: {
            'Accept': 'application/json'
          }
        });

        // 3. Success! Update UI and redirect
        this.status = "success";
        
        setTimeout(() => {
          // Assuming user is saved in localStorage, route them appropriately
          const loggedUser = localStorage.getItem("hrdos_user");
          const user = loggedUser ? JSON.parse(loggedUser) : null;
          
          if (user && user.id == 1) {
            this.$router.push("/employees");
          } else {
            this.$router.push("/my-profile");
          }
        }, 2500);

      } catch (error) {
        this.status = "error";
        
        // Check specific backend errors
        if (error.response) {
          if (error.response.status === 401) {
            this.errorMessage = "You must be logged in on this browser to verify your email.";
          } else if (error.response.status === 403) {
            this.errorMessage = "This verification link is invalid, altered, or has expired.";
          }
        }
      }
    }
  }
};
</script>